<template>
    <b-card-body>
        <p v-if="secciones.length === 0"><i>No hay secciones capturadas</i></p>
        <b-list-group v-else>
            <b-list-group-item v-for="(element, index) in secciones"
                :key="index"
                :to="'/comsocial/directorio/'+element._id">
                {{element.nombre}}
            </b-list-group-item>
        </b-list-group>

        <div v-if="puedeAgregarSeccion" class="text-right">
            <br>
            <b-button 
                size="sm"
                variant="primary"
                @click="agregarSeccion()">
                Agregar sección
            </b-button>
        </div>
    </b-card-body>
</template>

<script>
import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";

export default {
  name: 'ItemSecciones',
  props: ["secciones"],
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregarSeccion(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 124) >= 0 )
        return true;
      else
        return false;
    }
  },
  watch: {
      '$route'(to, from) {
        this.id = to.params.id;
      }
  },
  data: function () {
    return {
        titulo: this.$route.name,
        id: this.$route.params.id
    }
  },
  methods: {
    agregarSeccion(){
      swal({
        text: 'Ingrese nombre:',
        content: {
          element: "input",
          attributes: {
          placeholder: "Ingrese...",
          type: "text",
          }
        },
        closeOnClickOutside: true,
        button: {
          text: "Confirmar",
          closeModal: false,
        },
      })
      .then(nombre => {
        if (!nombre){
          swal.close();
        }else{
          this.$emit('enviandoStart');
          axios.post(this.httpURL+'/comsocial/directorio/menu/'+this.id,
                {nombre},
                {headers: {token:this.sessionToken}})
            .then(res => {
                swal.stopLoading();
                swal.close();
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                this.secciones.push(res.data.menu);
                this.$emit('enviandoStop');
            })
            .catch(error => {
                this.$emit('enviandoStop');
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
        }
      });
    },
    regresar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
